<template>
	<div class="flex-row-align-center flex-just-between">
		<div class="yx-border p-16 radius-8 flex-1 item" v-for="(item, index) in dataConfig" :key="index">
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center">
				<span>{{ item.label }}</span>
				<explain :content="item.plain" placement="right" class="ml-4"></explain>
			</div>
			<div class="yx-color-text-primary font-h3-medium mt-4 DIN">
				<span v-if="item.price">{{ item.number | formatEmpty | formatPrice3 | formatPrice2 | formatPrice }}</span>
				<span v-else>{{ item.number | formatEmpty | formatPrice2 }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';

export default {
	components: {
		Explain,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
		staticsData: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		dataConfig({ staticsData, platformId }) {
			let arr = [
				{
					label: '累计商品浏览量',
					number: 0,
					plain: '所有商品浏览量之和',
					price: false,
					key: 'views',
					isShow: [+dataMap.PLATFORM_DY.value, +dataMap.PLATFORM_KS.value].includes(+platformId),
				},
				{
					label: '累计报名商品',
					number: 0,
					plain: '成功通过商品公海的报名成功的商品数量',
					price: false,
					key: 'productCommonNum',
					isShow: [+dataMap.PLATFORM_DY.value, +dataMap.PLATFORM_KS.value].includes(+platformId),
				},
				{
					label: '累计报名团长数',
					number: 0,
					plain: '成功通过商品公海的报名成功的活动数',
					price: false,
					key: 'captainSignups',
					isShow: [+dataMap.PLATFORM_DY.value, +dataMap.PLATFORM_KS.value].includes(+platformId),
				},
				{
					label: '累计动销团长数',
					number: 0,
					plain: '成功通过商品公海的报名成功的活动对应的团长机构数',
					price: false,
					key: 'salesAuthorityNum',
					isShow: [+dataMap.PLATFORM_DY.value, +dataMap.PLATFORM_KS.value].includes(+platformId),
				},
				{
					label: '累计订单量',
					number: 0,
					plain: '所有成功通过商品公海的报名成功的商品商品，所有状态的商品订单数',
					price: false,
					key: 'orders',
					isShow: [+dataMap.PLATFORM_DY.value].includes(+platformId),
				},
				{
					label: '累计销售额',
					number: 0,
					plain: '成功通过商品公海的报名成功的商品，所有状态的商品订单的支付金额之和',
					price: true,
					key: 'totalAmount',
					isShow: [+dataMap.PLATFORM_DY.value].includes(+platformId),
				},
			];
			arr = arr
				.map(item => {
					return {
						...item,
						number: staticsData[item.key],
					};
				})
				.filter(item => item.isShow);
			return arr;
		},
	},
};
</script>
<style lang="less" scoped>
.item + .item {
	margin-left: 12px;
}
</style>